<div class="layout-footer back-footer">
    <img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'ClaroBlanco' : 'ClaroBlanco'}}.svg" alt="Logo" height="20"/>
    <span class="ml-2 pt-2" style="font-size: 0.87rem;">Aplicaciones Corporativas TI CENAM © </span>
</div>